var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d-container',{staticClass:"h-100",attrs:{"fluid":""}},[_c('d-row',{staticClass:"h-100"},[_c('d-col',{staticClass:"main-content px-0 h-100",attrs:{"tag":"main"}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }